import * as TYPES from "./mutation-types";

export default {
  [TYPES.SET_BRANDS](state, value) {
    state.brands = value;
  },
  [TYPES.SET_MODELS](state, value) {
    state.models = value;
  },
  [TYPES.SET_SERVICES](state, value) {
    state.services = value;
  },
  [TYPES.SET_DEALERS](state, value) {
    state.dealers = value;
  },
  [TYPES.SET_FETCHING](state, { key, value }) {
    state.fetching[key] = value;
  },
  [TYPES.SET_MODEL](state, value) {
    state.model = value;
  },
  [TYPES.SET_SERVICE](state, value) {
    state.service = value;
  },
  [TYPES.SET_RECOMENDATIONS](state, value) {
    state.recomendations = value;
  },
};
